// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, primaryColor, unit } from '@zego/theme';

import H3 from '@zego/components/atoms/H3';
import HeroTitle from '@zego/components/atoms/HeroTitle';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import Link from '@zego/components/Link';
import FlexRow from '@zego/components/molecules/FlexRow';
import StaticImage from '@zego/components/StaticImage';

import B2BCategoryImage from '@zego/static/images/blog-category-b2b.jpg';
import B2CCategoryImage from '@zego/static/images/blog-category-b2c.jpg';

const HERO_COPY = {
  kicker: 'Helping you make sense of insurance',
  title: 'Welcome to the Zego Blog',
  categories: [
    {
      id: 'self-employed',
      imageUrl: B2CCategoryImage,
      title: 'Self-employed',
      imageAlt: '',
      description:
        'Latest news and updates for individuals who use vehicles to earn money',
      url: '/blog/category/self-employed/',
    },
    {
      id: 'fleet',
      imageUrl: B2BCategoryImage,
      title: 'Fleets',
      imageAlt: '',
      description:
        'Latest news and updates for businesses who use vehicles to earn money',
      url: '/blog/category/fleets/',
    },
  ],
};

function Category({
  imageUrl,
  imageAlt,
  title,
  description,
  url,
}): JSX.Element {
  return (
    <article>
      <StaticImage
        src={imageUrl}
        alt={imageAlt}
        ratio={1.7}
        css={{
          width: '100%',
          borderRadius: unit(1),
          overflow: 'hidden',
        }}
      />
      <Spacer height={unit(2)} />
      <H3 css={{ [BREAKPOINTS.medium]: { fontSize: 22 } }}>{title}</H3>
      <p css={{ fontSize: 16 }}>{description}</p>
      <Link href={url} css={{ color: primaryColor(9) }}>
        View posts
      </Link>
    </article>
  );
}

export default function Hero(): JSX.Element {
  return (
    <View>
      <HeroContainer>
        <span
          css={{
            fontSize: 24,
            textAlign: 'center',
          }}
        >
          {HERO_COPY.kicker}
        </span>
        <Spacer height={unit(2)} />
        <HeroTitle css={{ textAlign: 'center' }}>{HERO_COPY.title}</HeroTitle>
      </HeroContainer>
      <ContentContainer css={{ paddingBottom: unit(10) }}>
        <CategoryContainer>
          <span
            css={{
              fontSize: 30,
              fontWeight: 600,
              [BREAKPOINTS.smallOnly]: {
                lineHeight: 1,
              },
              [BREAKPOINTS.medium]: { fontSize: 40 },
            }}
          >
            Jump to...
          </span>
          {HERO_COPY.categories.map(({ id, ...category }) => (
            <Category key={id} {...category} />
          ))}
        </CategoryContainer>
        <Spacer height={unit(6)} />
      </ContentContainer>
    </View>
  );
}

/**
 * Styled components
 */

const HeroContainer = styled(View)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: unit(50),
  background: `linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(245,244,255,0.9) 100%)`,
});

const ContentContainer = styled(View)({
  paddingLeft: unit(4),
  paddingRight: unit(4),
  margin: '0 auto',
  [BREAKPOINTS.medium]: {
    maxWidth: unit(11) + 1180 + unit(11),
    paddingLeft: unit(11),
    paddingRight: unit(11),
  },
});

const CategoryContainer = styled(FlexRow)({
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: unit(4),
  marginTop: unit(-12),
  [BREAKPOINTS.medium]: {
    marginTop: unit(-10),
    alignItems: 'center',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: unit(4),
  },
});
